import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { getImage } from "./utils";

export function MenuMain(props) {
  const context = useContext(Context);
  return (
    <>
      <div className="m_collapsible0">
        <div className="m0">
          <div className="m0_sticky">
            <MenuInner />
          </div>
        </div>
        <div className="m0_collapsed">
          <div className="m0_sticky">
            <MenuInner />
          </div>
        </div>
        <div className="m0_z" />
      </div>
    </>
  );
}

export function MenuInner(props) {
  const context = useContext(Context);
  return (
    <>
      <div className="m_section">
        <div className="m_title">
          <div className="m_ico">
            <div>home_work</div>
          </div>
          <div className="m_text">Dashboard</div>
        </div>
        <div className="m_ul">
          <Link to="/projects" className="m_li">
            <div className="m_ico">
              <div>content_copy</div>
            </div>
            <div className="m_text">
              <div>Projects</div>
            </div>
          </Link>

          {context.data["playlists"]
            .filter((one) => one["default"])
            .map((one) => (
              <MenuPlaylist key={`playlist_${one["id"]}`} {...one} />
            ))}

          {/* <div className="m_li">
            <div className="m_ico">
              <div>date_range</div>
            </div>
            <div className="m_text">
              <div>Playlists</div>
            </div>
          </div> */}

          {/* <div className="m_li">
            <div className="m_ico">
              <div>auto_awesome_motion</div>
            </div>
            <div className="m_text">
              <div>Timestreams</div>
            </div>
          </div> */}
        </div>
      </div>
      <div className="m_section">
        <div className="m_title">
          <div className="m_ico">
            <div>person</div>
          </div>
          <div className="m_text">Personal</div>
        </div>
        <div className="m_ul">
          {/* <div className="m_li">
            <div className="m_ico">
              <div>ondemand_video</div>
            </div>
            <div className="m_text">
              <div>My videos</div>
            </div>
          </div> */}
          {/* <div className="m_li">
            <div className="m_ico">
              <div>
                bookmark
                <br />
              </div>
            </div>
            <div className="m_text">
              <div>My favorites</div>
            </div>
          </div> */}

          {context.data["playlists"]
            .filter((one) => !one["default"])
            .map((one) => (
              <MenuPlaylist key={`playlist_${one["id"]}`} {...one} />
            ))}
        </div>
      </div>
      <div className="m_bot">
        <div className="m_ul">
          <div className="m_li">
            <div className="m_ico">
              <div>tune</div>
            </div>
            <div className="m_text">
              <div>Settings</div>
            </div>
          </div>
          <div className="m_li">
            <div className="m_ico">
              <div>feedback</div>
            </div>
            <div className="m_text">
              <div>Feedback</div>
            </div>
          </div>

          <div className="m_li">
            <div className="m_ico">
              <div
                className="m_user_ava"
                style={{
                  backgroundImage: `url("${getImage(context.user["img"])}")`,
                }}
              />
            </div>
            <div className="m_text">
              <div>mikoza@gmail.com</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function MenuPlaylist({ id, uniq, title, emoji, icon }) {
  const context = useContext(Context);
  return (
    <>
      <Link to={`/list/${uniq}`} className="m_li">
        {Boolean(emoji) && <div className="m_ico m_ico_emojis">{emoji}</div>}
        {Boolean(icon) && <div className="m_ico">{icon}</div>}
        <div className="m_text">{title}</div>
      </Link>
    </>
  );
}
